export const lang = {
    page1: {
        title: ' More than just games',
        title1: ' Unleash your creative potential and retrieve the original happiness.',
        des: 'Scan QR code to download.',
        goBack: 'Home'
    },
    page2: {
        title: 'Extreme user experience',
        des: 'Help excellent games been matched with the right people while the players enjoying the fun beyond games. 233 Playground has been committed to providing quality games appeal to all ages. People of any age can find joy and huge possibilities in games.',
    },
    page3: {
        title: 'Inspire Creativity',
        des: 'The meaning of games is more than just entertainment. In fact, games have been adding inspiration to our lives and subtly improving our quality of life. 233 Playground has been committed to finding such games and sharing them with more people.',
    },
    page4: {
        title: 'Promote Culture',
        des: 'Games are the favorite way of entertainment for teenagers.  Integrate traditional culture and teach through games would be more accepted and recognized by teenagers. Countless intellectual games keep your mind sharp. 233 Playground would be your most special teacher.',
    },
    page5: {
        title: 'Positive Value',
        des: '233 Playground has been working to explore the value of games in all areas. In addition to providing entertainment for people, games can also be the carrier of cultural exchanges and talent training to guide positive values. 233 Playground will always deliver the positive values to every user.',
    },
}


// WEBPACK FOOTER //
// ./src/VueI18n/language-en.js